import styled from 'styled-components'

export const ContainerWelcome = styled.div`
  width: 80%;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Container = styled.div`
  width: 300px;
  height: 200px;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 3rem;
`
export const ContainerInfo = styled.div`
  margin-top: 2rem;
  width: 50%;
`
